import * as constants from '../constants'

export const setNotifications = (notifications) => {
  return {
    type: constants.SET_NOTIFICATIONS,
    notifications,
  }
}

export const addNotification = (notification) => {
  return {
    type: constants.ADD_NOTIFICATION,
    notification,
  }
}

export const getNotifications = () => {
  return {
    type: constants.GET_NOTIFICATIONS,
  }
}

export const addFilteredNotifications = (notifications, chargeBoxId) => {
  return {
    type: constants.ADD_FILTERED_NOTIFICATIONS,
    notifications,
    chargeBoxId
  }
}

export const addFilteredNotification = (notification, chargeBoxId) => {
  return {
    type: constants.ADD_FILTERED_NOTIFICATION,
    notification,
    chargeBoxId
  }
}

export const addFilteredUserNotifications = (notifications, userPk) => {
  return {
    type: constants.ADD_FILTERED_USER_NOTIFICATIONS,
    notifications,
    userPk
  }
}

export const addFilteredUserNotification = (notification, userPk) => {
  return {
    type: constants.ADD_FILTERED_USER_NOTIFICATION,
    notification,
    userPk
  }
}